import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { FaEye } from 'react-icons/fa';
import { Alert } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import api from '../../../../utils/api';

export const MyPortfolioReview = ({ roomId,handleTabChange }) => {
  const [isPrArchive, setIsPrArchive] = useState([]);
  const navigate = useNavigate();
  const mapWhyPR = (whyPR) => {
    const reasons = {
      '1': 'Returns Led Risk Reduction',
      '2': 'Periodic Rebalancing',
      '3': 'Life Event Based Review',
    };
    if (!whyPR) return '';
    const reasonsArray = whyPR.split(',').map((key) => reasons[key.trim()]);
    return reasonsArray.join(', ');
  };

  useEffect(() => {
    const getPrArchive = async () => {
      try {
        const response = await api.get(
          `advisor/getPrArchive/${roomId}`
        );
        setIsPrArchive(response.data || []);
      } catch (error) {
        console.error('Error fetching portfolio review data:', error);
      }
    };
    getPrArchive();
  }, [roomId]);

  const renderStatus = (item) => {
    if (item.portfolio_review_status === 'Executed') return 'Executed';
    if (item.portfolio_review_status === 'Discard') {
      if (item.portfolio_review_discard_reason === 'Declined by Client') return 'Declined';
      if (item.portfolio_review_discard_reason === 'Time Lapse') return 'Time Lapse';
    }
    return '-';
  };


  const handleViewArchiveData = (key) => {
  const formattedDate = key.new_pr_date
    ? new Date(key.new_pr_date).toISOString()
    : "";

  const url = `/portfolio-review-detail/?clientId=${roomId}&prId=${key.portfolio_review_id}&prDate=${formattedDate}`;
  navigate(url);
};


  const getStatusClass = (item) =>
    item.portfolio_review_status === 'Executed' ? 'clrlightgreen' : 'back-clrred';

  if (isPrArchive.length === 0) {
    return (
      <Alert
        variant="success"
        className="fw-bold d-block text-center mt-4"
      >
        No Data Found
      </Alert>
    )
  }
  return (
    <div className="row">
      <div className="col">
        {/* ✅ DESKTOP VIEW */}
        <div className="d-none d-md-block">
          <table className="table table-striped table-hover">
            <thead>
              <tr>
                <th className="txt-color-revers sticky-header back-clrgreen fs-14 m-0 text-center">
                  S. #
                </th>

                <th className="txt-color-revers sticky-header back-clrgreen fs-14 m-0">Date</th>
                <th className="txt-color-revers sticky-header back-clrgreen fs-14 m-0">Reviewed Reason</th>
                <th className="txt-color-revers sticky-header back-clrgreen fs-14 m-0">Status</th>
                {/* <th className="txt-color-revers sticky-header back-clrgreen fs-14 m-0">Remarks</th> */}
                <th className="txt-color-revers sticky-header back-clrgreen fs-14 m-0">View</th>
              </tr>
            </thead>
            <tbody>
              {isPrArchive.length === 0 ? (
                <tr>
                  <td colSpan="6" className="text-center">
                    <p className="fs-14 fw-normal">No Data Found</p>
                  </td>
                </tr>
              ) : (
                [...isPrArchive]
  .sort((a, b) => new Date(b.portfolio_review_created_at) - new Date(a.portfolio_review_created_at))
  .map((item, index) => (

                  <tr key={item._id}>
                    <th><p className="fs-14 fw-normal ms-5 m-0">{index + 1}</p></th>
                    <td>
                      <p className="fs-14 fw-normal m-0">
                        {new Date(item.portfolio_review_created_at).toLocaleDateString('en-GB', {
                          day: '2-digit',
                          month: 'short',
                          year: 'numeric',
                        })}
                      </p>
                    </td>
                    <td><p className="fs-14 fw-normal m-0">{mapWhyPR(item.why_pr)}</p></td>
                    <td>
                      <button className={`fs-14 border-0 px-2 py-1 rounded-3 m-0 ${getStatusClass(item)}`}>
                        {renderStatus(item)}
                      </button>
                    </td>
                    {/* <td><p className="fs-14 fw-normal m-0">{item.portfolio_review_discard_reason || ''}</p></td> */}
                    <td>
        <FaEye
          style={{ cursor: "pointer" }}
                        className="clrgreen cursor-pointer"
                        onClick={() => handleViewArchiveData(item)}
                      />
                      {/* <a
                        href={`dashboard/portfolio-review-detail/${item.portfolio_review_id}/?clientId=${roomId}`}
                        rel="noopener noreferrer"
                      >
                        <img src="assets/images/Eye.svg" alt="View" className="eye" />
                      </a> */}
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>

        {/* ✅ MOBILE VIEW */}
        <div className="d-block d-md-none">
          {isPrArchive.length === 0 ? (
            <p className="text-center">No Data Found</p>
          ) : (
            [...isPrArchive]
  .sort((a, b) => new Date(b.portfolio_review_created_at) - new Date(a.portfolio_review_created_at))
  .map((item, index) => {
              const formattedDate = new Date(item.portfolio_review_created_at).toLocaleDateString(
                'en-GB',
                { day: '2-digit', month: 'short', year: 'numeric' }
              );
              return (
                <div
                  key={item._id}
                  className="border rounded-3 p-3 mb-3 bg-white shadow-sm"
                  style={{ fontSize: "14px", lineHeight: "1.4" }}
                >
                  {/* Header row with index and view icon */}
                  <div className="d-flex justify-content-between align-items-center mb-2">
                    <span className="fw-bold">#{index + 1}</span>
                    {/* <a
                      href={`dashboard/portfolio-review-detail/${item.portfolio_review_id}/?clientId=${roomId}`}
                      rel="noopener noreferrer"
                      className="ms-auto"
                    >
                      <img
                        src="assets/images/Eye.svg"
                        alt="View"
                        className='eye'
                        style={{ width: "20px", height: "20px" }}
                      />
                    </a> */}
                    <FaEye
                      style={{ cursor: "pointer" }}
                      className="clrgreen cursor-pointer"
                      onClick={() => handleViewArchiveData(item)}
                    />
                  </div>

                  {/* Data fields */}
                  <div className="mb-2 d-flex justify-content-between">
                    <strong>Date:</strong> <span>{formattedDate}</span>
                  </div>

                  <div className="mb-2 d-flex justify-content-between">
                    <strong>Reviewed Reason:</strong>
                    <span>{mapWhyPR(item.why_pr)}</span>
                  </div>

                  <div className="mb-2 d-flex justify-content-between">
                    <strong>Status:</strong>

                    <span className=''
                    >
                      {item.portfolio_review_status === 'Executed'
                        ? 'Accepted'
                        : item.portfolio_review_status === 'Discard' &&
                          item.portfolio_review_discard_reason === 'Declined by Client'
                          ? 'Declined'
                          : item.portfolio_review_discard_reason === 'Time Lapse'
                            ? 'Time Lapse'
                            : '-'}
                    </span>

                  </div>

                  {item.portfolio_review_discard_reason && (
                    <div className="mb-1">
                      <strong>Remarks:</strong>
                      <div>{item.portfolio_review_discard_reason}</div>
                    </div>
                  )}
                </div>
              );
            })
          )}
        </div>

      </div>
    </div>
  );
};
